var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"6c0bb97c84319ddd03e3d3c7e497ecd45414d049"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["user-web-app@eleanto-gmbh"]={id:"6c0bb97c84319ddd03e3d3c7e497ecd45414d049"};
      